module.exports = __webpack_public_path__ + "img/monitor-img3.6d640008.png";